<template>
    <div class="home-dashboard-client-list">
        <div class="home-dashboard-client-list__actions">
            <div v-if="sorted.length"
                class="home-dashboard-client-list__sort input select">
                <label>Sort By</label>
                <select v-model="sortBy">
                    <option value="name">Name</option>
                    <option value="updated_at">Last Modified</option>
                </select>
            </div>
            <slot name="actions"></slot>
        </div>
        <div class="client-list">
            <div v-for="client in sorted"
                :key="`client-${client.id}`"
                class="home-dashboard-client-list__client">
                <div class="home-dashboard-client-list__header">
                    <img v-if="client.logo"
                        :src="client.logo"
                        class="home-dashboard-client-list__header-logo">
                    <div v-else
                        class="home-dashboard-client-list__header-logo">
                        {{ client.abbreviation }}
                    </div>
                    <h3 class="home-dashboard-client-list__header-title">{{ client.name }}</h3>
                    <p v-if="client.description" class="home-dashboard-client-list__header-description ellipsis ellipsis--3">{{ client.description }}</p>
                    <p v-if="client.integration_id" class="element-badge is--info">Portal-Integrated</p>
                    <a
                        :href="`/clients/${client.id}`"
                        class="element-button--secondary element-button">
                        View Client
                    </a>
                </div>
                <div v-if="client.projects.length" class="home-dashboard-client-list__body">
                    <a v-for="project in sortedProjects(client.projects)"
                        :key="`project-${project.id}`"
                        class="home-dashboard-client-list__project app-card"
                        :href="projectLink(project)">
                        <h4 class="app-card__title">
                            {{ project.name }}
                            <toggle-favorite :project-id="project.id"></toggle-favorite>
                        </h4>
                        <p class="app-card__description ellipsis ellipsis--3">{{ project.description }}</p>
                        <p class="app-card__metric-last-modified app-card__metric">
                            Last modified {{ localizeDate(project.last_modified_date).format('MMM D, YYYY h:mm A') }}
                        </p>
                    </a>
                </div>
            </div>
            <div v-if="!sorted.length">
                <h4>Nothing is currently available.</h4>
                <p>Sorry, it looks like you haven't been assigned to any clients yet.</p>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import ToggleFavorite from './ToggleFavorite'
import store from '../store'
import { localizeDate } from '../helpers/util'

export default {
    store,
    components: { ToggleFavorite },
    data () {
        return {
            sortBy: 'name'
        }
    },
    computed: {
        sorted () {
            const sorted = _.orderBy(this.$store.state.clients, [item => (item[this.sortBy].toLowerCase())])
            if (this.sortBy === 'updated_at') { // this needs to be inverted
                return _.reverse(sorted)
            }
            return sorted
        }
    },
    methods: {
        localizeDate,
        sortedProjects(projects) {
            const sortField = this.sortBy === 'updated_at' ? 'last_modified_date' : this.sortBy
            const sorted = _.orderBy(projects, [item => (item[sortField].toLowerCase())])
            if (this.sortBy === 'updated_at') { // this needs to be inverted
                return _.reverse(sorted)
            }
            return sorted
        },
        projectLink(project) {
            return project.is_lite_mode ? `/projects/${project.id}/courses` : `/projects/${project.id}`
        }
    }
}
</script>
